function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeToPushNotifications() {
  // 1. Detect iOS/iPadOS
  // iPads on iPadOS 13+ report as MacIntel, but have touch points.
  // iPhone and older iPads are caught by the regex.
  const isIos =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  // 2. Check for Standalone Mode (PWA)
  // 'standalone' in navigator is a reliable indicator for iOS/iPadOS
  const isInStandaloneMode =
    // biome-ignore lint/suspicious/noExplicitAny: iOS standalone check
    ("standalone" in navigator && (navigator as any).standalone) ||
    window.matchMedia("(display-mode: standalone)").matches;

  // 3. iOS-specific requirement: Must be a PWA for Web Push
  if (isIos && !isInStandaloneMode) {
    throw new Error("Please add this app to your Home Screen to enable notifications.");
  }

  // 4. Standard Feature Detection
  if (
    !("serviceWorker" in navigator) ||
    !("PushManager" in window) ||
    !("Notification" in window)
  ) {
    console.warn("Push notifications not supported in this browser.");
    return null;
  }

  try {
    // Register the service worker if it's not already
    const registration = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;

    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      return { subscription: existingSubscription, isNew: false };
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied.");
      return null;
    }

    const vapidPublicKey = "BLCh-s8YlWvhzCgKvbYvtqSdSfJBCODZlycExjF2CuaJJDFN2gFxtVPvhO6Gymzfi-J_Ys4qiOTtcana0vZJIlo";
    if (!vapidPublicKey) {
      console.error("VAPID Public Key is missing from the environment.");
      return null;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    });
    return { subscription, isNew: true };
  } catch (error) {
    console.error("Push subscription failed:", error);
    return null;
  }
}
